import ApplicationPaymentsLoading from "../components/loaders/ApplicationPaymentsLoading";
import { AgreementPayment } from "../components/webhooks/AgreementPayment";
import { useApplication } from "../hooks/useApplication";
import { useUser } from "../hooks/useUser";

const Page = () => {
  const application = useApplication();
  const user = useUser();
  if (!application || !user) {
    return <ApplicationPaymentsLoading />;
  }
  return <AgreementPayment />;
};

export default Page;
